module.exports = __webpack_public_path__ + "static/media/ricardo-perez-headset.9f3a3031.svg";